import { useTranslation } from "react-i18next";
import { DialogBox } from "../../../common/components/functional/dialogBox/DialogBox";
import { useState } from "react";
import { Box, FormControl, Typography } from "@mui/material";
import { TextFieldLight } from "../../../common/components/styled/styled";

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
  finishSave: (editReason: string) => void;
  isLoading: boolean;
}

export const OrderSaveDialog = ({
  isOpen,
  closeDialog,
  finishSave,
  isLoading,
}: Props) => {
  const { t } = useTranslation(["common", "order"]);

  const [editReason, setEditReason] = useState("");

  const updateEditReason = (event: any) => {
    setEditReason(event.target.value);
  };

  const finishDialog = () => {
    finishSave(editReason);
    setEditReason("");
  };

  const cancelDialog = () => {
    setEditReason("");
    closeDialog();
  };

  const steps = [
    {
      label: t("invoiceType"),
      component: (
        <Box>
          <Typography sx={{ marginBottom: "15px" }}>
            {t("order:addEditReason")}
          </Typography>
          <FormControl fullWidth>
            <TextFieldLight
              size="small"
              value={editReason}
              onChange={updateEditReason}
              helperText={t("order:onlyVisibleToEezy")}
              inputProps={{ maxLength: 2048 }}
            />
          </FormControl>
        </Box>
      ),
      disableNext: editReason.length === 0,
    },
  ];

  return (
    <DialogBox
      isOpen={isOpen}
      dialogTitle={t("order:saveOrder")}
      onCancelDialog={cancelDialog}
      onFinishDialog={finishDialog}
      steps={steps}
      cancelLabel={t("cancel")}
      finishLabel={t("save")}
      isLoading={isLoading}
    />
  );
};
